import { green, grey, orange, red } from "@mui/material/colors";
import { allMessages, getProfileLanguage } from "i18n/i18nProvider";
import { EmailJobStatusFieldType } from "pages/SharedRecords.types";

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function languageChoices() {
  return Object.entries(translatedLanguageMapping()).map(([code, label]) => ({ id: code, name: label }));
}

export function translatedLanguageMapping() {
  const locale = getProfileLanguage();
  const messages = allMessages[locale as keyof typeof allMessages] ?? allMessages.de;
  return messages.languages ?? {};
}

export const emailStatuses: { label: string; field: EmailJobStatusFieldType; color: string }[] = [
  {
    label: "waiting_for_transfer",
    field: "waiting_for_transfer_count",
    color: orange[500],
  },
  { label: "transfered", field: "transfered_count", color: grey[500] },
  { label: "sent", field: "sent_count", color: green[500] },
  { label: "blocked", field: "blocked_count", color: red[500] },
  { label: "error", field: "error_count", color: red[500] },
];
